import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from '../../shared';
import { DataQueryDto } from './dto/data-query.dto';
import { DataQuerySearchDto } from './dto/data-query-search.dto';

@Injectable({
  providedIn: 'root',
})
export class DataQueryService {
  constructor(private _apiService: ApiService) {}

  public getMySavedDataQueries(searchParams: DataQuerySearchDto): Promise<PagedResultGeneric<DataQueryDto>> {
    return this._apiService.getPaged('report/mydataqueries', searchParams);
  }

  exportDataQueryToCsv(dataQueryId: number): Promise<string> {
    return this._apiService.get(`report/dataquery/${dataQueryId}/export`);
  }

  exportDataQueryWithDateParamsToCsv(dataQuery: DataQueryDto): Promise<string> {
    return this._apiService.post(`report/dataquery/${dataQuery.Id}/export`, dataQuery.DateParameters);
  }

  getQueryProfileIds(dataQueryId: number): Promise<Array<number>> {
    return this._apiService.get(`report/dataquery/${dataQueryId}/profileids`);
  }

  getQueryProfileIdsWithDates(dataQuery: DataQueryDto): Promise<number[]> {
    return this._apiService.post(`report/dataquery/${dataQuery.Id}/profileids`, dataQuery.DateParameters);
  }
}
